import { useContext } from "react";
import { RegenerateInvoicePdfActionContext } from "./RegenerateInvoicePdfActionContext";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import store from "@beeldit/core/services/store";

function useRegenerateInvoicePdf() {
  const { setShowModal, invoiceId } = useContext(RegenerateInvoicePdfActionContext);
  const handleError = useErrorHandler();

  return (onSuccess: () => void) => {
    if (!invoiceId) return;
    store(`invoices/${invoiceId}/regenerate-pdf`, { method: "POST" })
      .then(() => {
        setShowModal(false);
        onSuccess();
      })
      .catch((error: any) => {
        handleError(error);
      });
  };
}

export default useRegenerateInvoicePdf;